'use strict';
/**
 * @author Maxim Seredkin
 */
import {
  getUserCertificates,
  createHash,
  createDetachedSignature,
  getCertificate,
} from '../../../crypto-pro/crypto-pro';

export default [
  '$scope',
  '$rootScope',
  'Notification',
  'SignService',
  'ModalService',
  'ProjectService',
  function (
    $scope,
    $rootScope,
    Notification,
    SignService,
    ModalService,
    ProjectService
  ) {
    //$scope.mapUserCertsToCerts = mapUserCertsToCerts;
    $scope.selectAll = selectAll;
    $scope.selectProject = selectProject;
    $scope.isContainSelect = isContainSelect;
    $scope.isSelectAll = isSelectAll;
    $scope.selectCount = selectCount;
    $scope.isSelectedCert = isSelectedCert;
    $scope.selectCert = onSelectCert;
    $scope.onSignClick = onSignClick;
    $scope.deleteCert = onDeleteCert;
    $scope.onClickSelectNewCert = onClickSelectNewCert;
    $scope.isAllowSign = isAllowSign;
    $scope.mousedown = mousedown;
    $scope.mouseup = mouseup;
    $scope.mousemove = mousemove;
    $scope.projectsLoading = false;
    $scope.certsLoading = false;
    $scope.userCertificates = [];
    $scope.certs = [];
    $scope.projects = [];
    $scope.pagination = {
      size: 10,
      totalItems: 0,
      totalPages: 0,
      page: 1,
    };
    $scope.selectedCert = null;
    $scope.selectedProjects = {};
    $scope.formatDate = formatDate;
    $scope.refetchProjects = () => {
      $scope.projectsLoading = true;
      fetchProjects();
    };

    // Переменные стейта для работы слайдера
    let isDown = false;
    const delta = 6;
    let startX;
    let startY;
    let scrollLeft;

    // Проверка клика в слайдере
    function checkDeltaToClick($event, slider) {
      const diffX = Math.abs($event.pageX - slider.offsetLeft - startX);
      const diffY = Math.abs($event.pageY - slider.offsetTop - startY);
      if (diffX < delta && diffY < delta) return true;
      return false;
    }

    async function fetchBackCertificates() {
      try {
        const backCertificates = await SignService.api.certificates().$promise;
        $scope.certsLoading = false;
        if (!Array.isArray(backCertificates._embedded)) return;
        $scope.certs = backCertificates._embedded.map(mapBackCerts);
        $scope.selectedCert = $scope.certs[0] || null;
        $scope.$apply();
      } catch (err) {
        $scope.certsLoading = false;
        console.log(err);
        $scope.$apply();
      }
    }

    // Фетч сертификатов из контейнера
    async function fetchUserCertificates() {
      try {
        $scope.userCertificates = await getUserCertificates(true);
        $scope.userCertificates = $scope.userCertificates.map(mapUserCerts);
        $scope.$apply();
      } catch (err) {
        Notification.danger({
          title: 'Ошибка!',
          message: err.toString(),
        });
        $scope.$apply();
      }
    }

    // Фетч проектов
    async function fetchProjects() {
      try {
        const backProjects = await SignService.api.projects({
          page: $scope.pagination.page,
          size: $scope.pagination.size,
        }).$promise;
        $scope.projectsLoading = false;
        if (!Array.isArray(backProjects._embedded))
          throw new Error('Не удалось получить проекты');
        $scope.projects = backProjects._embedded;
        $rootScope.projectsToSignCount = angular.copy(
          backProjects.page.totalElements
        );
        $scope.pagination.totalItems = backProjects.page.totalElements;
        $scope.pagination.totalPages = backProjects.page.totalPages;
        selectAll();
        $scope.$apply();
      } catch (err) {
        $scope.projectsLoading = false;
        $scope.$apply();
        console.log(err);
      }
    }

    // Маунт страницы
    function init() {
      $rootScope.title = "";
      $scope.projectsLoading = true;
      $scope.certsLoading = true;
      fetchUserCertificates();
      fetchBackCertificates();
      fetchProjects();
    }
    init();

    // Маппинг сертификатов бэкенда в нужную форму для показа в слайдере
    function mapBackCerts(item) {
      return {
        thumbprint: item.token,
        owner: item.accessor,
        validFrom: item.from,
        validTo: item.to,
        validToLocaleString: new Date(item.to).toLocaleDateString('ru', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }),
        status: convertDateToStatus(item.to),
      };
    }
    // Маппинг сертификатов хранилища в нужную форму для показа в слайдере
    function convertDateToStatus(dateString) {
      const currentDate = new Date();
      const expiredDate = new Date(dateString);
      // Если осталось больше месяца
      if (expiredDate - currentDate > 2629743833.3) return 'valid';
      // Если протух
      if (expiredDate - currentDate < 0) return 'expired';
      return 'ends';
    }

    function mapUserCerts(item) {
      return {
        ...item,
        thumbprint: item.thumbprint,
        owner: item.name,
        validFrom: item.validFrom,
        validTo: item.validTo,
        validToLocaleString: new Date(item.validTo).toLocaleDateString('ru', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        }),
        status: convertDateToStatus(item.validTo),
      };
    }

    // Работа со списком проектов
    function selectProject(item) {
      $scope.selectedProjects[item.id] = !$scope.selectedProjects[item.id];
    }

    function selectAll() {
      const isAllProjectsSelected = $scope.isSelectAll();
      $scope.selectedProjects = $scope.projects.reduce((acc, item) => {
        if (item.enableSigning === false) {
          acc[item.id] = false;
        } else {
          acc[item.id] = !isAllProjectsSelected;
        }
        return acc;
      }, {});
    }

    function isContainSelect(item) {
      if (!item.id) return;
      return $scope.selectedProjects[item.id];
    }

    function isSelectAll() {
      return $scope.projects.every((item) => $scope.selectedProjects[item.id]);
    }

    function selectCount() {
      return $scope.projects.filter((item) => $scope.selectedProjects[item.id])
        .length;
    }

    // Работа с подписью проектов
    function isAllowSign() {
      if ($scope.projectsLoading) return false;
      if (!$scope.selectedCert) return false;
      for (let key in $scope.selectedProjects) {
        if ($scope.selectedProjects[key]) return true;
      }
      return false;
    }

    function onSignClick() {
      if (!isAllowSign()) {
        Notification.danger({
          title: 'Ошибка!',
          message: 'Не выбран сертификат или проект',
        });
      }
      $scope.projectsLoading = true;
      processSign();
    }

    async function processSign() {
      try {
        const thumbprint = $scope.selectedCert.thumbprint;
        const result = await Promise.all(
          $scope.projects
            .filter((item) => $scope.selectedProjects[item.id])
            .map(async (item) => {
              const signHash = await createHash(item.hash, 'string');
              const signature = await createDetachedSignature(
                thumbprint,
                signHash
              );
              return {
                id: item.id,
                sign: signature.replace(/\r|\n/g, ''),
              };
            })
        );
        const response = await SignService.api.sign(null, {
          token: thumbprint,
          signs: result,
        }).$promise;
        if (
          response._embedded &&
          Array.isArray(response._embedded.signs) &&
          response._embedded.signs.some((item) => item.result)
        ) {
          fetchProjects();
          $scope.selectedProjects = {};
        } else {
          $scope.$apply();
        }
      } catch (err) {
        Notification.danger({
          title: 'Ошибка!',
          message: err.toString(),
        });
        $scope.projectsLoading = false;
        $scope.$apply();
      }
    }

    // Работа с сертификатами в слайдере
    function onSelectCert($event, cert) {
      const slider = $event.currentTarget.parentElement;
      if (!checkDeltaToClick($event, slider)) return false;
      $scope.selectedCert = cert;
    }

    function onDeleteCert($event, cert) {
      const slider = $event.currentTarget.parentElement.parentElement;
      if (!checkDeltaToClick($event, slider)) return false;
      $event.stopPropagation();
      ModalService.warning({
        message:
          'Сертификат будет удален из списка доступных для подписания! Вы действительно желаете удалить данный сертификат?',
        apply: 'Да',
        cancel: 'Нет',
      })
        .result.then(async () => {
          if (
            $scope.selectedCert &&
            $scope.selectedCert.thumbprint === cert.thumbprint
          )
            $scope.selectedCert = {};
          await SignService.api.remove({ id: cert.thumbprint }).$promise;
          await fetchBackCertificates();
        })
        .catch((err) => {
          Notification.danger({
            title: 'Ошибка удаления сертификата!',
            message: err.toString(),
          });
        });
    }

    function isSelectedCert(item) {
      if (!$scope.selectedCert) return false;
      return $scope.selectedCert.thumbprint === item.thumbprint;
    }

    function onClickSelectNewCert() {
      $scope.certsLoading = true;
      SignService.select($scope.userCertificates)
        .result.then(async (selectedCertFromModal) => {
          if (!selectedCertFromModal)
            throw new Error('Не выбран сертификат для загрузки');
          const currentCertificate = await getCertificate(
            selectedCertFromModal.thumbprint
          );
          const base64Content = await currentCertificate.exportBase64();
          return {
            token: selectedCertFromModal.thumbprint,
            accessor: selectedCertFromModal.name,
            from: selectedCertFromModal.validFrom,
            to: selectedCertFromModal.validTo,
            content: base64Content.replace(/\r|\n/g, ''),
          };
        })
        .then(async (body) => {
          const result = await SignService.api.send(null, body).$promise;
          if (result && result.code !== 200)
            throw new Error(
              `Ошибка загрузки сертификата: ${result._embedded || ''}`
            );
          fetchBackCertificates();
        })
        .catch((err) => {
          $scope.certsLoading = false;
          if (!err) return;
          $scope.$apply();
          Notification.danger({
            title: 'Ошибка!',
            message: err.toString(),
          });
        });
    }

    // Работа с драгом по слайдеру
    function mousedown($event) {
      const slider = $event.currentTarget;
      slider.style.cursor = 'grabbing';
      isDown = true;
      startX = $event.pageX - slider.offsetLeft;
      startY = $event.pageY - slider.offsetTop;
      scrollLeft = slider.scrollLeft;
    }

    function mouseup($event) {
      const slider = $event.currentTarget;
      isDown = false;
      slider.style.cursor = 'grab';
    }

    function mousemove($event) {
      const slider = $event.currentTarget;
      if (!isDown) return;
      $event.preventDefault();
      const x = $event.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1;
      slider.scrollLeft = scrollLeft - walk;
    }

    function formatDate(date) {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      if (!date || typeof date !== 'string') return '';
      const dateObject = new Date(date);
      return `${dateObject.toLocaleDateString(
        'ru',
        options
      )} ${dateObject.toLocaleTimeString('ru')}`;
    }
  },
];
